import { useEffect } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import Hero from './components/Hero'
import Services from './components/Services'
import About from './components/About'
import Products from './components/Products'
import Philosophy from './components/Philosophy'
import CTASection from './components/CTASection'
import Footer from './components/Footer'
import Navigation from './components/Navigation'
import SEO from './components/SEO'
import './App.css'

function App() {
  useEffect(() => {
    // Add subtle background pattern
    const pattern = document.createElement('div')
    pattern.className = 'background-pattern'
    document.body.appendChild(pattern)
    
    return () => {
      document.body.removeChild(pattern)
    }
  }, [])

  return (
    <HelmetProvider>
      <SEO />
      <div className="app">
        <Navigation />
        <Hero />
        <About />
        <Services />
        <Products />
        <Philosophy />
        <CTASection />
        <Footer />
      </div>
    </HelmetProvider>
  )
}

export default App
